import decode from 'jwt-decode'

type DecodedToken = {
  exp: number
  iat: number
  id: string
}

export const decodeAccessToken = (token: string) => {
  if (token === 'NOT_FOUND' || !token) {
    return undefined
  }
  return decode(token) as DecodedToken
}
